<template>
  <div>
    <b-overlay :show="loading">
      <b-container fluid>
        <span 
          v-if="etapyDvigeniya"
          @click="visible = 'etapy'"
          :class="visible === 'etapy' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Этапы движения</span>
      </b-container>

      <div v-show="visible === 'etapy'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Маршрут</label>
                  </b-col>
                  <b-col sm="10">
                    <b-list-group horizontal="md" class="d-flex">
                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['pogruzka_plan'], editedData['pogruzka_fact'])">
                        <div>
                          <span class="small-description">адрес погрузки</span>
                          {{ editedData.naselenniy_punkt || '<Здесь будет населенный пункт>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['pogruzka_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['pogruzka_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['vilet_plan'], editedData['vilet_fact'])">
                        <div>
                          <span class="small-description">аэропорт отправления</span>
                          {{ editedData.aeroport_of_otpravleniya || '<Здесь будет аэропорт отправления>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['vilet_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['vilet_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['prilet_plan'], editedData['prilet_fact'])">
                        <div>
                          <span class="small-description">аэропорт прибытия</span>
                          {{ editedData.aeroport_of_naznacheniya || '<Здесь будет аэропорт прибытия>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['prilet_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['prilet_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>

                      <b-list-group-item class="b-group-item-end" :variant="variantByTwoDays(editedData['dostavka_plan'], editedData['dostavka_fact'])">
                        <div>
                          <span class="small-description">адрес разгрузки</span>
                          {{ editedData.address_of_unloading || '<Здесь будет адрес разгрузки>' }}
                        </div>
                        <div class="mt-2">
                          <div><small><b>План:</b> {{ editedData['dostavka_plan'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                          <div><small><b>Факт:</b> {{ editedData['dostavka_fact'] || '<Дата пока не указана>' | formattedDate }}</small></div>
                        </div>
                      </b-list-group-item>
                    </b-list-group>                    
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

          </b-container>
        </b-card>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import {
  constantsAllReferenceProperties,
  dateHelpers,
  dataHelpers
} from '@/mixins';

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    saveMode: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      required: true,
    },
    filteredDocs: {
      type: Array,
      required: true,
    },
    etapyDvigeniya: {
      type: Boolean,
      default: true,
    },
    defaultVisible: {
      type: String,
      default: 'etapy',
    },
  },
  mixins: [
    constantsAllReferenceProperties,
    dateHelpers,
    dataHelpers
  ],
  components: {},
  data() {
    return {
      loading: false,
      localEditMode: false,
      visible: 'etapy',
      editedData: {
        "0": { value: '' },
        "1": { value: '' },
        name_of_cargo: '',
        import_export: 'Импорт',
        usloviya_postavki_id: null,
        naselenniy_punkt: '',
        number_of_places: 0,
        weight: 0,
        volume: 0,
        platniy_weight: 0,
        cargo_sender_name: '',
        address_g_o: '',
        contact_name_on_shipment: '',
        cargo_recipient_name: '',
        inn_g_p: '',
        kpp_g_p: '',
        address_g_p: '',
        address_of_unloading: '',
        contact_name_on_unloading: '',
        tamogenniy_post_svh_id: null,

        aeroport_of_otpravleniya: '',
        aeroport_of_naznacheniya: '',
        tranzitniy_aeroport: '',
        nomer_of_awb: '',
        nomer_reisa: '',
        data_vypuska_awb: '',
        nazvanie_perevozchika: '',

        gotovnost_gruza_plan: '',
        gotovnost_gruza_fact: '',
        pogruzka_plan: '',
        pogruzka_fact: '',
        vilet_plan: '',
        vilet_fact: '',
        prilet_plan: '',
        prilet_fact: '', 

        transitnoe_vremya: '',

        zakritie_dostavki_plan: '',
        zakritie_dostavki_fact: '',
        podacha_dt_plan: '',
        podacha_dt_fact: '',
        vypusk_dt_plan: '',
        vypusk_dt_fact: '',
        time_of_to: '',

        dostavka_plan: '',
        dostavka_fact: '',
        obshee_transitnoe_vremya: ''
      },
    };
  },
  computed: {
    transitnoe_vremya() {
      if (!this.editedData['prilet_fact'] || !this.editedData['pogruzka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['pogruzka_fact'], this.editedData['prilet_fact']);
      return transitnoe_vremya;      
    },
    time_of_to() {
      if (!this.editedData['vypusk_dt_fact'] || !this.editedData['podacha_dt_fact']) {
        // return 'Заполните поля <Выпуск ДТ> и <Подача ДТ>';
        return "<Расчет недоступен>";
      } 

      const time_of_to = this.getDiffNumberOfDays(this.editedData['podacha_dt_fact'], this.editedData['vypusk_dt_fact']);
      return time_of_to;
    },
    obshee_transitnoe_vremya() {
      if (!this.editedData['pogruzka_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['pogruzka_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya;      
    },
    platniy_weight() {
      if (!this.editedData['weight'] || !this.editedData['volume']) {
        return '<Расчет недоступен>';
      } 

      let tempWeight = this.editedData['volume'] * 167;

      if (tempWeight < this.editedData['weight']) {
        return this.editedData['weight'];
      }
        
      return tempWeight;
    }
  },
  watch: {
    editMode: {
      handler(value) {
        this.localEditMode = value;
      },
      immediate: true
    },
    saveMode: {
      handler(value) {
        if (value == true) {
          this.$emit('updateData', this.editedData);
        }
      },
      immediate: true
    },
    detailedItem: {
      handler(data) {
        this.editedData = this.deepMergeSafeFirst(JSON.parse(JSON.stringify(data.data)), JSON.parse(JSON.stringify(this.editedData)));
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    setReferenceValue(value, reference_id, index) {
      this.editedData[index] = value;
    },
    changeSelectedDoc(doc) {
      this.editedData[0].value = doc.name;
      this.editedData[1].value = doc.date_of_document;
    },
  },
  mounted() {
    this.visible = this.defaultVisible;
  },
};
</script>
<style scoped>
.custom-select {
  height: 34px !important;
  border-radius: 3px !important;
  padding: 1px 8px;
}
.small-description {
  line-height: 11px;
}

.b-group-item-end {
  display: flex !important;
  justify-content: space-between !important;
}

.b-group-item-end b {
  text-transform: none;
}
</style>